import { render, staticRenderFns } from "./box_3.vue?vue&type=template&id=e18f428a&scoped=true&"
import script from "./box_3.vue?vue&type=script&lang=js&"
export * from "./box_3.vue?vue&type=script&lang=js&"
import style0 from "./box_3.vue?vue&type=style&index=0&id=e18f428a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18f428a",
  null
  
)

export default component.exports